import { useFirestore } from "../../../firebase/useFirestore";
import ToggleButton from "../../common/ToggleButton";

/**
 * Instelling: mag de materiaalvoorraad onder 0 zakken?
 *
 * Uit (standaard) weigert een registratie zodra er te weinig voorraad is. Aan
 * laat de registratie door en toont de voorraad als tekort — de gebruiker
 * krijgt eerst een bevestiging te zien.
 */
const AllowNegativeStock = () => {
    const compagny = useFirestore("CompagnyMeta");

    return (
        <div className="dashboard-container">
            <h2>Voorraad mag negatief worden</h2>
            <p>
                Zet aan om materialen te kunnen registreren terwijl de voorraad
                op is. De voorraad komt dan in de min te staan. Voordat dit
                gebeurt vragen we om een bevestiging. Staat dit uit, dan wordt de
                registratie geweigerd zolang er te weinig voorraad is.
            </p>
            {compagny && compagny.map((comp) => (
                <div key={comp.ID} className="settings-general-module-settings-item-container">
                    <p>Negatieve voorraad toestaan</p>
                    <ToggleButton
                        docid={comp.docid}
                        id={"AllowNegativeStock"}
                        collection={"CompagnyMeta"}
                        value={comp.AllowNegativeStock}
                    />
                </div>
            ))}
        </div>
    );
};

export default AllowNegativeStock;
